import request from '../utils/request';
const querystring = require('querystring')
//获取下拉框数据
export const fetchGradeSelect = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMember/getGradeSelect.do',
        method: 'post',
        params: query
    }); 
    return list;
};
//获取列表数据
export const fetchData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMember/selectUser.do',
        method: 'post',
        params: query
    }); 
    return list;
};

//获取所有成员列表数据
export const changeRole = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMember/changeRole.do',
        method: 'post',
        params: query
    }); 
    return list;
};

export const getSelect = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkGrade/getSelect.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};


export const saveForm = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMember/saveMember.do',
        method: 'post',
        params: query
    }); 
    return list;
};
export const handDelete = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMember/deleteMemGrade.do',
        method: 'post',
        params: query
    }); 
    return list;
};
export const changeForm = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMember/changeMemLevel.do',
        method: 'post',
        params: query
    }); 
    return list;
};

export const updateSave = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMember/updateSave.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handleStatus = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMember/handleStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};



export const exchangeMember = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMember/exchangeMember.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getTreeData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkChannel/getTreeData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
export const getCheckData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMemberChannel/checkTreeData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const saveBind = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMemberChannel/saveBind.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};









